import {
  login,
  logout,
  getAccountList,
  register,
  resetPassword,
  deleteAccount,
  getRestaurants,
  bindManage
} from '../api'
import {
  SET_ACCOUNT_LIST,
  SET_ACCOUNT_INFO,
  GLOBAL_CACHE,
  SET_RESTAURANT_OPTIONS
} from './mutation_types'

const state = {
  account: '',
  roleId: null,
  accountList: [],
  restaurantOptions: null
}

const getters = {
  roleId: state => state.roleId,
  account: state => state.account
}

const actions = {
  login({ commit }, { reqParam, cb, errorCb }) {
    login(reqParam).then(res => {
      const { success, data_collect: data, msg } = res.data

      if (!success) {
        errorCb && errorCb(msg)
        return
      }

      commit(SET_ACCOUNT_INFO, data)
      commit(GLOBAL_CACHE)
      cb && cb(data)
    })
  },
  logout({ commit }, { cb, errorCb }) {
    logout().then(res => {
      const { success, msg } = res.data

      if (!success) {
        errorCb && errorCb(msg)
        return
      }
      cb && cb()
    })
  },
  initAccountList({ commit }, reqParam) {
    getAccountList(reqParam).then(res => {
      commit(SET_ACCOUNT_LIST, res.data)
    })
  },
  register({ commit }, { reqParam, cb, errorCb }) {
    register(reqParam).then(res => {
      const { success, msg } = res.data

      if (!success) {
        errorCb && errorCb(msg)
        return
      }

      cb && cb()
    })
  },
  resetPassword({ commit }, { reqParam, cb, errorCb }) {
    resetPassword(reqParam).then(res => {
      const { success, msg } = res.data

      if (!success) {
        errorCb && errorCb(msg)
        return
      }

      cb && cb()
    })
  },
  deleteAccount({ commit }, { reqParam, cb, errorCb }) {
    deleteAccount(reqParam).then(res => {
      const { success, msg } = res.data

      if (!success) {
        errorCb && errorCb(msg)
        return
      }

      cb && cb()
    })
  },
  getRestaurants({ commit }) {
    getRestaurants().then(res => {
      commit(SET_RESTAURANT_OPTIONS, res.data.data_collect)
    })
  },
  bindManage({ commit }, { reqParam, cb, errorCb }) {
    bindManage(reqParam).then(res => {
      const { success, msg } = res.data

      if (!success) {
        errorCb && errorCb(msg)
        return
      }

      cb && cb()
    })
  }
}

const mutations = {
  [SET_ACCOUNT_LIST](state, data) {
    state.total = data.data_count || 0
    state.accountList = data || []
    state.data = data
  },
  [SET_ACCOUNT_INFO](state, data) {
    state.account = data.account
    state.roleId = data.roleId
  },
  [GLOBAL_CACHE](state) {},
  [SET_RESTAURANT_OPTIONS](state, data) {
    state.restaurantOptions = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js